import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import * as THREE from 'three';
import {manager} from "../System/LoadingManager";

interface GLTF {
    scene: THREE.Object3D;
}

type LoadModelCallback = (gltf: GLTF) => void;
type ProgressCallback = (progress: ProgressEvent) => void;
type ErrorCallback = (error: unknown) => void;

export function loadModel(
    url: string,
    onLoad: LoadModelCallback,
    onProgress?: ProgressCallback,
    onError?: ErrorCallback
): void {
    const loader = new GLTFLoader(manager);
    loader.load(
        url,
        (gltf: GLTF) => {
            onLoad(gltf);
        },
        (progress: ProgressEvent) => {
            if (onProgress) {
                onProgress(progress);
            }
        },
        (error: unknown) => {
            console.error('Erreur de chargement du modèle:', error);
            if (onError) {
                onError(error);
            }
        }
    );
}
